import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { Download, Smartphone, Check } from "lucide-react"
import { usePWAInstall } from "@/hooks/use-pwa-install"
import { useLanguage } from "@/hooks/use-language"
import { cn } from "@/lib/utils"

interface PWAInstallButtonProps {
  variant?: "default" | "outline" | "ghost"
  size?: "sm" | "default" | "lg"
  showBadge?: boolean
  className?: string
}

export function PWAInstallButton({ 
  variant = "default", 
  size = "default",
  showBadge = false,
  className 
}: PWAInstallButtonProps) {
  const { language } = useLanguage()
  const { isInstallable, isInstalled, installApp } = usePWAInstall()

  const handleInstall = async () => {
    try {
      await installApp()
    } catch (error) {
      console.error('Error installing PWA:', error)
    }
  }

  if (isInstalled) {
    return (
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size={size}
          disabled
          className={cn("gap-2", className)}
        >
          <Check className="w-4 h-4" />
          {language === "en" ? "Installed" : "Instalado"}
        </Button>
        {showBadge && (
          <Badge variant="outline" className="border-primary/30 text-primary">
            {language === "en" ? "PWA" : "PWA"}
          </Badge>
        )}
      </div>
    )
  }

  if (!isInstallable) {
    return null
  }

  return (
    <div className="flex items-center gap-2">
      <Button
        variant={variant}
        size={size}
        onClick={handleInstall}
        className={cn("gap-2", className)}
      >
        <Download className="w-4 h-4" />
        {language === "en" ? "Install App" : "Instalar App"}
      </Button>
      {showBadge && (
        <Badge variant="outline" className="border-primary/30 text-primary">
          <Smartphone className="w-3 h-3 mr-1" />
          {language === "en" ? "Available" : "Disponible"}
        </Badge>
      )}
    </div>
  )
}
